import { motion } from "framer-motion";
import { fadeIn } from "../variants.jsx";
import Resume from "../../public/assets/Arsen_Zuna_Resume.pdf";
import Arsen from "../../public/assets/Arsen.jpeg";
import ArsenHover from "../../public/assets/ArsenHover.jpeg";
import { skillsData } from "../utils/data.jsx";
import React from "react";
import Footer from "./Footer.jsx";

const Hero = () => {
	return (
		<div className="sticky top-0 w-full px-5 lg:px-8">
			<div className="pt-14 xl:pt-24">
				<div className="ml-2 md:ml-20">
					<motion.div
						variants={fadeIn("down")}
						initial="hidden"
						whileInView="show"
						viewport={{ once: true, amount: 0.4 }}
					>
						<div className="relative group">
							<img
								src={Arsen}
								alt="ArsenZuna"
								className="mx-auto w-52 h-52 md:w-72 md:h-72 rounded-full object-cover group-hover:hidden"
							/>
							<img
								src={ArsenHover}
								alt="ArsenZuna Hover"
								className="mx-auto w-52 h-52 md:w-72 md:h-72 rounded-full object-cover hidden group-hover:block"
							/>
						</div>
					</motion.div>
					<motion.h1
						variants={fadeIn("down")}
						initial="hidden"
						whileInView="show"
						viewport={{ once: true, amount: 0.4 }}
						className="text-5xl text-center font-bold tracking-tight text-gray-300 hover:text-white pt-6"
					>
						Arsen Zuna
					</motion.h1>
					<motion.p
						variants={fadeIn("up")}
						initial="hidden"
						whileInView="show"
						className="pt-3 text-lg text-gray-300 text-center italic"
					>
						Software Developer
					</motion.p>
					<div>
						<div className="flex justify-center gap-4 xl:gap-6 pt-14 xl:pt-20">
							{skillsData.map((item, index) => {
								return (
									<motion.div
										key={index}
										initial={{ y: 0 }}
										animate={{ y: [0, -15, 0] }} // up and down
										transition={{
											duration: 3, // total time for one up-and-down cycle
											repeat: Infinity, // loop forever
											delay: index * 0.4, // stagger based on icon index
											ease: "easeInOut",
										}}
									>
										<img
											src={item.icon}
											alt={item.alt}
											className="w-5 h-5 md:w-7 md:h-7"
										/>
									</motion.div>
								);
							})}
						</div>
					</div>
					<div className="pt-14 xl:pt-40 text-gray-300 hover:text-white transition-all duration-500 text-md italic">
						<p>
							" There is nothing noble in being superior to your fellow man, true
							nobility is being superior to your former self. "
						</p>
						<p className="py-2 px-5 text-end">~ Ernest Hemingway</p>
					</div>
					<div className="flex justify-center xl:hidden pt-10">
						<Footer />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Hero;
